import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import { colors } from "@permisso/permisso-components";

const SOMETHING_WENT_WRONG_TITLE = "Oops... something went wrong!";

export const ErrorScreen = ({ error }: { error?: Error }) => {
  const style: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  };

  return (
    <div style={style}>
      <ErrorCard error={error} />
    </div>
  );
};

export const ErrorCard = ({ error }: { error?: Error }) => {
  const style: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "1.5rem",
  };

  const errorMessageCardStyle: React.CSSProperties = { gap: "0.5rem", textAlign: "center" };

  return (
    <div style={style}>
      <Icon size={ICON_SIZES.s75} color={colors.defaultRed} path={ICON_PATHS.SIGNPOST} />
      <div style={errorMessageCardStyle}>
        <p>
          <strong>{SOMETHING_WENT_WRONG_TITLE}</strong>
        </p>
        {error ? error.message : null}
      </div>
    </div>
  );
};
